import { Link } from 'react-router-dom';

interface CTASectionProps {
  variant?: 'mid' | 'bottom';
}

export default function CTASection({ variant = 'bottom' }: CTASectionProps) {
  if (variant === 'mid') {
    return (
      <section className="py-16 px-6 lg:px-12 bg-teal-700">
        <div className="max-w-5xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-8">
          <div>
            <p className="text-teal-200 text-sm font-semibold tracking-widest uppercase mb-2">Ready to Get Answers?</p>
            <h2 className="font-heading text-3xl font-bold text-white mb-2">
              Start With a Free 10-Minute Consultation
            </h2>
            <p className="text-teal-200 text-base">
              No obligation. Just an honest conversation about whether Dr. Leder's approach is right for you.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 flex-shrink-0">
            <a
              href="tel:2015251155"
              className="flex items-center justify-center gap-2 bg-white text-teal-800 px-7 py-3.5 rounded-md text-sm font-semibold hover:bg-teal-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-teal-700 text-base"></i>
              </div>
              Call (201) 525-1155
            </a>
            <Link
              to="/contact"
              className="flex items-center justify-center gap-2 bg-teal-900 text-white px-7 py-3.5 rounded-md text-sm font-semibold hover:bg-teal-950 transition-colors cursor-pointer whitespace-nowrap"
            >
              Book Online
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-base"></i>
              </div>
            </Link>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 px-6 lg:px-12 relative overflow-hidden" style={{ background: '#0f4a40' }}>
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://public.readdy.ai/ai/img_res/a95f7e6d9b938fb45d012a5ae7f7e892.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <p className="text-teal-400 text-sm font-semibold tracking-widest uppercase mb-4">Take the First Step</p>
        <h2 className="font-heading text-4xl lg:text-5xl font-bold text-white mb-5 leading-tight">
          Your Health Transformation<br />Starts with One Call
        </h2>
        <p className="text-teal-200 text-lg mb-3 max-w-2xl mx-auto leading-relaxed">
          Hundreds of patients across Bergen County, NJ have found real answers here after years of frustration with the conventional medical system. You could be next.
        </p>
        <p className="text-amber-400 text-sm font-semibold mb-10">
          ✦ Free 10-Minute Phone Consultation Available Now
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="tel:2015251155"
            className="flex items-center justify-center gap-2 bg-white text-teal-900 px-8 py-4 rounded-md text-base font-semibold hover:bg-teal-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-teal-700 text-lg"></i>
            </div>
            Call (201) 525-1155
          </a>
          <Link
            to="/contact"
            className="flex items-center justify-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-md text-base font-semibold hover:bg-teal-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            Book Appointment Online
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calendar-check-line text-white text-lg"></i>
            </div>
          </Link>
        </div>
        <p className="text-teal-400 text-xs mt-6">
          235 Prospect Avenue Suite LB, Hackensack, NJ · (201) 525-1155 · a.better.alternative.medical@gmail.com
        </p>
      </div>
    </section>
  );
}
